<template>
  <div
    v-if="relations?.length"
    :class="$style.root"
  >
    <div :class="$style.label">
      {{ $t('events.related.label', { count: relations?.length }) }}
    </div>
    <coreBoxListComponent :class="$style.content">
      <template
        v-for="relation in relationsPaginated"
        :key="relation?.id"
      >
        <SharedEventsLinkComponent
          :data="relation"
          :class="$style.link"
        >
          <CoreBoxListItemComponent :class="$style.item">
            <SharedEventsThumbnailComponent :data="relation" :showTags="false" />
          </CoreBoxListItemComponent>
        </SharedEventsLinkComponent>
      </template>
    </coreBoxListComponent>

    <button
      v-if="relations?.length > limit && paginated"
      :class="$style.button"
      @click="paginated = false"
    >
      {{ $t('shared.showAll', { count: relations?.length }) }}
    </button>
  </div>
</template>

<script lang="ts" setup>
const props = defineProps<{
  page: object
}>()

const limit = 8
const paginated = ref(true)

const relations = props?.page?.eventEntries?.data
const relationsPaginated = computed(() => paginated.value ? relations?.slice(0, limit) : relations)
</script>

<style module>
.root {
  composes: container from global;
  margin-top: calc(var(--unit--vertical) * 2);
}

.content {
}

.label {
  composes: font-helvetica font-size-small from global;
  composes: label from global;
}

.list {
  composes: reset-list from global;
}

.link {
  display: contents;
}

.button {
  composes: reset-button font-helvetica font-size-small link from global;
  margin-top: var(--padding--element--top);
}
</style>
